module.exports = __webpack_public_path__ + "img/404.27225666.png";